import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { createRef, memo, useMemo, } from 'react';
import { Icon, } from '../Icon';
import { useExpandableButtonStyles } from './useExpandableButtonStyles';
const defaultProps = {
    inputRef: createRef(),
    modifier: 'expand',
    onBlur: () => { },
    onClick: () => { },
    onFocus: () => { },
    onKeyDown: () => { },
    onKeyUp: () => { },
    onMouseDown: () => { },
    onMouseLeave: () => { },
    onMouseUp: () => { },
    onTouchEnd: () => { },
    onTouchMove: () => { },
    onTouchStart: () => { },
};
const ExpandableButton = ({ inputRef = defaultProps.inputRef, modifier = defaultProps.modifier, onBlur = defaultProps.onBlur, onClick = defaultProps.onClick, onFocus = defaultProps.onFocus, onKeyDown = defaultProps.onKeyDown, onKeyUp = defaultProps.onKeyUp, onMouseDown = defaultProps.onMouseDown, onMouseLeave = defaultProps.onMouseLeave, onMouseUp = defaultProps.onMouseUp, onTouchEnd = defaultProps.onTouchEnd, onTouchMove = defaultProps.onTouchMove, onTouchStart = defaultProps.onTouchStart, }) => {
    const buttonStyles = useExpandableButtonStyles({
        modifier,
    });
    const iconType = useMemo(() => (modifier === 'expand'
        ? 'add'
        : 'subtract'), [
        modifier,
    ]);
    const buttonText = useMemo(() => (modifier === 'expand'
        ? 'View more'
        : 'View less'), [
        modifier,
    ]);
    return (_jsxs("button", Object.assign({ css: buttonStyles, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, ref: inputRef, type: "button" }, { children: [_jsx("span", { children: buttonText }), _jsx(Icon, { size: "extraSmall", type: iconType })] })));
};
const MemoizedExpandableButton = memo(ExpandableButton);
export { MemoizedExpandableButton as ExpandableButton };
// MC-1068 Temporary hack for Storybook.
export default ExpandableButton;
